<div class="applicant-step">
  <ul class="applicant-step__process-list">
    <li i18n>View and receive your personalized quote via email</li>
    <li i18n>Attend free consultations to customize your package</li>
  </ul>
  <div class="applicant-step__form">
    <lx-applicant-details (submitForm)="submitLead()"></lx-applicant-details>
  </div>
</div>
